import { meta, shopify, starbucks, tesla } from "../assets/images";
import BlazedKid from "../assets/BK.png";
import Ricks from "../assets/RN.jpeg";
import jdmspark from "../assets/jdmspark.png";
import pcevolvers from "../assets/pcevolversNObg.png";
import surbing from "../assets/surbing_no_bg.png";
import figma from "../assets/icons/Figma.png";
import net from "../assets/icons/net.png";
import vs from "../assets/icons/vs.png";
import namecheap from "../assets/icons/name.png";
import replit from "../assets/icons/rep.png";
import PreBuild from "../assets/images/PreBuild.png";
import Crypto from "../assets/images/Crypto.png";
import JDMLover from "../assets/images/JDMLover.png";
import WEBUNSANA from "../assets/images/WEBUNSANA.png";
import CoverMee from "../assets/covermee_no_bg.png";
import WGP from "../assets/carbile.png";
import Tandarosca from "../assets/tandaroscasolo.png";
// import surbing from "../components/CaseStudy/Styles/surbing.png"
import threetry from "../components/CaseStudy/Styles/threetry_NO_BG_LOGO.png"
import FirebaseLogo from '../logo/skills/firebase.png';


import {
    car,
    contact,
    css,
    estate,
    git,
    github,
    html,
    javascript,
    linkedin,
    mongodb,
    mui,
    nextjs,
    nodejs,
    pricewise,
    react,
    sass,
    snapgram,
    summiz,
    tailwindcss,
    threads,
} from "../assets/icons";

export const skills = [
    // {
    //     imageUrl: html,
    //     name: "HTML",
    //     type: "Frontend",
    // },
    // {
    //     imageUrl: css,
    //     name: "CSS",
    //     type: "Frontend",
    // },
    // {
    //     imageUrl: git,
    //     name: "Git",
    //     type: "Version Control",
    // },
    // {
    //     imageUrl: javascript,
    //     name: "JavaScript",
    //     type: "Frontend",
    // },
    {
        imageUrl: github,
        name: "GitHub",
        type: "Version Control",
        descOne: "Deployed frontend projects to Netlify via GitHub integration, enabling continuous deployment on every push and pull request.",
        descTwo: "Configured build settings and environment variables directly through Netlify for seamless CI/CD workflows.",
        descThree: "",
    },
    {
        imageUrl: FirebaseLogo,
        name: "Firebase",
        type: "Database & Auth",
        descOne: "Implemented Firebase for real-time database management using Cloud Firestore and integrated Firebase Authentication to enable secure, seamless user login across the platform.",
        descTwo: "Leveraged Firebase’s Authentication and Firestore services to create a responsive, cloud-based infrastructure that supports secure login functionality and dynamic data updates.",
        descThree: "",
    },
    // {
    //     imageUrl: mongodb,
    //     name: "MongoDB",
    //     type: "Database",
    // },
    // {
    //     imageUrl: mui,
    //     name: "Material-UI",
    //     type: "Frontend",
    // },
    // {
    //     imageUrl: nextjs,
    //     name: "Next.js",
    //     type: "Frontend",
    // descOne: "",
    // descTwo: "",
    // descThree: "",
    // },
    {
        imageUrl: net,
        name: "Netlify",
        type: "Frontend",
        descOne: "Implemented continuous deployment pipelines by integrating GitHub with Netlify for seamless and automated frontend project deployments.",
        descTwo: "Configured environment variables, custom domains, and HTTPS to ensure secure and scalable web hosting.",
        descThree: "Leveraged deploy previews and serverless functions to accelerate development cycles and enhance site performance.",
    },
    {
        imageUrl: namecheap,
        name: "Namecheap",
        type: "Backend",
        descOne: "Used Namecheap to register custom domains and manage DNS settings for personal and portfolio websites.",
        descTwo: "Connected domains to platforms like Netlify and GitHub Pages for live deployment.",
        descThree: "Gained experience with domain management, nameservers, and basic SSL configuration.",
    },
    {
        imageUrl: replit,
        name: "Replit AI",
        type: "Frontend",
        descOne: "Leveraged AI assistance to debug code, generate functions, and understand new programming concepts.",
        descTwo: "Learned to write and improve code using Replit AI’s in-editor suggestions and explanations.",
        descThree: "Built and deployed small web apps to reinforce coding knowledge.",
    },
    {
        imageUrl: react,
        name: "React",
        type: "Frontend",
        descOne: "Improved my understanding of component-based architecture and conditional rendering.",
        descTwo: "Used React to build small personal projects and practice frontend development. ",
        descThree: "Learned how to pass data through props and update the UI with state changes.",
    },
    {
        imageUrl: vs,
        name: "Visual Studio Code",
        type: "Frontend",
        descOne: "Utilized Visual Studio Code as a primary development environment for building responsive web applications with HTML, CSS, JavaScript, and React.",
        descTwo: "Used extensions and snippets to speed up workflow and improve code consistency.",
        descThree: "Used the integrated terminal and Git support to run projects and manage version control efficiently.",
    },
    {
        imageUrl: shopify,
        name: "Shopify",
        type: "E-Commerce",
        descOne: "Managed themes, product listings, and third-party app integrations to extend store functionality and optimize performance.",
        descTwo: "Collaborated on site design, branding, and checkout flow improvements to align with business goals and improve customer engagement.",
        descThree: "",
    },
    {
        imageUrl: figma,
        name: "Figma",
        type: "E-Commerce",
        descOne: "Used Figma to design clean, user-friendly interfaces for web and mobile projects.",
        descTwo: "Created wireframes, mockups, and simple interactive prototypes to share ideas and gather feedback.",
        descThree: "Designed web and mobile screens in Figma as part of personal projects.",
    },
];

export const experiences = [
    {
        title: "Meat Clerk",
        company_name: "Super Fresh Market",
        iconBg: "#accbe1",
        date: "June 2013 - Aug 2014",
        points: [
            "Identifeid spoilage and damaged merchandise for proper disposal.",
            "Received and processed shipments of incoming merchandise.",
            "Ensured proper placement and product ratation of incoming inventory.",
            "Monitored and replineshed merchandise as needed.",
            "Maintained area beautification to create an enchanced shopping exprience.",
        ],
    },
    {
        title: "Associate",
        company_name: "Likewize",
        // icon: tesla,
        iconBg: "#fbc3bc",
        date: "Oct 2016 - Feb 2018",
        points: [
            "Record shipment data such tracking packaged compliance, damages or discrepancies for accounting and record-keeping purposes.",
            "Processed returns by serial number using a PC based wordstation that consisted of Likewize sotfware.",
            "Organized devices by port number and valued devices by qaulity",
        ],
    },
    {
        title: "Merchandiser",
        company_name: "ThredUp",
        // icon: shopify,
        iconBg: "#b7e4c7",
        date: "Jan 2018 - Apr 2021",
        points: [
            "Assist in a company initiave / demonstrating sportsmanship, thoughtful solving, communicatin and recapping.",
            "Responsible for auditing inventory based attributes including gender and season.",
            "Strong attention to detail for item accuracy and qaulity.",
            "Styled and photographed clothing, in order to ensure an overall elevate site aesthetic.",
        ],
    },
    {
        title: "Custom PC Builder",
        company_name: "Lyte Technology",
        // icon: shopify,
        iconBg: "#b768c5",
        date: "May 2021- May 2023",
        points: [
            "Performed upgrades, repairs test and cleaned desktop compputer systems.",
            "Budgeted, Ordered and Built computer systems from parts for various clientele.",
            "Configured and built computer systems to client specifications and budget Related Projects.",
            "Served as a computer technician both testing and assembling many varieties of computers assemble custom, small form factor computer systems.",
            "Inspected and diagnosed wiring installation and issues to maintain safety.",
        ],
    },
    {
        title: "Desktop Support Tech",
        company_name: "CDW",
        // icon: meta,
        iconBg: "#a2d243",
        date: "Oct 2023 - Present",
        points: [
            "Resolved service request by individually troubleshoting and addressing user issues. ",
            "Lent technical support, consulting and implementing services to maintain system performance thresholds.",
            "Evaluated software testing, deployment and updates to maintain complaince with organization mandates.",
            "Troubleshot desktop and notebook issues with clients and CDW employees.",
            "Reviewed current hardware and softwre configurations and recommended modifations to increase system speed.",
        ],
    },
];

export const socialLinks = [
    {
        name: 'Contact',
        iconUrl: contact,
        link: '/contact',
    },
    {
        name: 'GitHub',
        iconUrl: github,
        link: 'https://github.com/estelo2jz',
    },
    {
        name: 'LinkedIn',
        iconUrl: linkedin,
        link: 'https://www.linkedin.com/in/estelo-abellanosa-83a335186',
    }
];

export const projects = [
    {
        iconUrl: threetry,
        theme: 'btn-back-black',
        name: 'Proxy, Safeguard, & Parcel',
        description: "By identifying a user problem and focusing on their specific needs. Using AI as a tool, I developed a responsive website tailored to the user's needs, ensuring accessibility, clarity, and ease of navigation.",
        link: 'https://threetry.com',
        Technologies: "Replit AI - UX Design"
    },
    // {
    //     iconUrl: surbing,
    //     theme: 'btn-back-yellow',
    //     name: 'SURBING',
    //     description: "I developed a responsive website tailored to the user's needs, ensuring accessibility, clarity, and ease of navigation. The website was designed with advanced filtering options and personalized recommendations, enabling users to find relevant solutions quickly and efficiently.",
    //     link: 'https://surbing.com',
    //     Technologies: "Replit AI - UX Design"
    // },
    {
        iconUrl: Tandarosca,
        theme: 'btn-back-red',
        name: 'Tandarosca',
        description: "Is a collaborative savings platform that connects users to pool their funds and grow their savings collectively. Whether it's short-term goals or long-term financial planning.",
        // SaveTogether allows members to choose contract lengths that fit their needs. By committing to a shared savings plan, users can benefit from increased financial security, smart goal-setting, and even potential rewards for staying committed. Team up, save smarter, and reach financial goals faster—together!
        link: 'https://www.tandarosca.com/',
        Technologies: "React - SCSS - UX Design",
    },
    // {
    //     iconUrl: shopify,
    //     theme: 'btn-back-pink',
    //     name: 'UNSANA',
    //     description: "This is my personal brand, thoughtfully crafted as a deep dive into the fascinating realm of branding and identity design. It serves as a reflection of my creativity, strategic thinking, and passion for shaping unique and memorable brand identities while exploring the intricacies of what makes a brand truly resonate with its audience.",
    //     link: 'https://www.unsana.shop/',
    //     Technologies: "Shopify - E-Commerce"
    // },
    // {
    //     iconUrl: Ricks,
    //     theme: 'btn-back-red',
    //     name: 'RN Tattoo',
    //     description: "I created a personal tattoo website using React, integrating a smooth booking functionality for clients to schedule appointments easily. The site showcases tattoo work, providing an engaging and intuitive experience for users exploring designs and availability.",
    //     link: 'https://ricksnayupac.com/',
    //     Technologies: "React - SCSS",
    // },
    {
        iconUrl: WGP,
        theme: 'btn-back-red',
        name: 'Carbile',
        description: "Carbile is a mobile-first auto repair platform that brings professional, certified car care directly to your doorstep — no waiting rooms, no stress. Built with modern web technologies like React and SCSS, the application offers a seamless experience tailored for busy drivers who value time, transparency, and trustworthy service.",
        link: 'https://carbile.com/',
        Technologies: "React - SCSS",
    },
    {
        iconUrl: BlazedKid,
        theme: 'btn-back-red',
        name: 'Blazed Kid NFT',
        description: "TCrafted a dynamic and visually immersive platform for showcasing, trading, and minting NFTs, seamlessly blending creativity with cutting-edge blockchain technology.",
        link: 'https://blazedkid.com/',
        // link: 'https://blazed-kid.netlify.app/',
        Technologies: "React - SCSS",
    },
    {
        iconUrl: jdmspark,
        theme: 'btn-back-red',
        name: 'JDM Spark',
        description: "Designed and developed a sleek, user-friendly platform for showcasing authentic JDM imports, enhancing both functionality and visual appeal.",
        // link: 'https://jdmspark.com/',
        link: 'https://jdmspark.com/',
        Technologies: "React - SCSS",
    },
    {
        iconUrl: pcevolvers,
        theme: 'btn-back-red',
        name: 'PC Evolvers',
        description: "Developed an intuitive and visually engaging platform to help users design and customize their dream PCs with ease.",
        // link: 'https://www.pcevolvers.com/',
        link: 'https://pcevolvers.netlify.app/',
        Technologies: "React - SCSS",
    },
    // {
    //     iconUrl: JDMLover,
    //     theme: 'btn-back-green',
    //     name: 'JDM Lover',
    //     description: 'Online Dealership For Japanese Domestic Market',
    //     link: 'https://jdmlover.netlify.app/',
    // },
    // {
    //     iconUrl: PreBuild,
    //     theme: 'btn-back-blue',
    //     name: 'PRE-BUILD PC',
    //     description: "Online High End Gaming PC's",
    //     link: 'https://pre-build.netlify.app/',
    // },

];